export const STATUS_MAP = {
  green: { label: "Ready", color: "#34C759" },
  amber: { label: "In Progress", color: "#FFCC00" },
  red: { label: "Critical", color: "#FF3B30" },
  grey: { label: "Not Set", color: "#8E8E93" },
};

export function StatusDot({ status = "grey", live = false }) {
  const c = STATUS_MAP[status]?.color || "#8E8E93";
  return (
    <span
      className={`status-dot ${live ? "live" : ""}`}
      style={{ backgroundColor: c, boxShadow: `0 0 8px ${c}55` }}
      data-testid={`status-dot-${status}`}
    />
  );
}

const TASK_STATUS_COLOR = {
  pending: "#8E8E93",
  in_progress: "#FFCC00",
  completed: "#34C759",
  issue_identified: "#FF3B30",
  assigned: "#FFCC00",
  delayed: "#FF3B30",
  escalated: "#FF3B30",
  acknowledged: "#FFCC00",
  ready: "#34C759",
  not_inspected: "#8E8E93",
  open: "#FF3B30",
  resolved: "#34C759",
};

const PRIO_COLOR = {
  critical: "#FF3B30",
  high: "#FFCC00",
  medium: "#8E8E93",
  low: "#8E8E93",
};

export function StatusBadge({ status, kind = "task", live = false }) {
  const label = String(status).replace(/_/g, " ");
  const color = TASK_STATUS_COLOR[status] || "#8E8E93";
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest border"
      style={{
        color,
        borderColor: `${color}66`,
        background: `${color}14`,
      }}
      data-testid={`status-badge-${kind}-${status}`}
    >
      <span className={`status-dot ${live ? "live" : ""}`} style={{ backgroundColor: color }} />
      {label}
    </span>
  );
}

export function PriorityBadge({ priority, done = false }) {
  // Completed / resolved items don't need an urgent priority badge — mute
  // to grey so the row visually reads as "done" instead of continuing to
  // shout CRITICAL / HIGH after the fact.
  const color = done ? "#8E8E93" : (PRIO_COLOR[priority] || "#8E8E93");
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest border"
      style={{ color, borderColor: `${color}66`, background: `${color}14` }}
      data-testid={`priority-badge-${priority}${done ? "-done" : ""}`}
    >
      {priority}
    </span>
  );
}
